import { mdlForgotPasswordRequest } from "../models/service-models/auth/ForgotPasswordRequest";
import { mdlLoginRequest } from "../models/service-models/auth/LoginRequest";
import { mdlLoginResponse } from "../models/service-models/auth/LoginResponse";
import { mdlResetPasswordRequest } from "../models/service-models/auth/ResetPasswordRequest";
import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlUserAccountResponse } from "../models/service-models/auth/UserAccountResponse";
import { mdlUserAccountRequest, mdlUpdateUserAccountRequest } from "../models/service-models/auth/UserAccountRequest";
import { GetResponse } from "../utils/ApiClient";

export namespace AuthService {
  export async function Login(
    pRequest: mdlLoginRequest
  ): Promise<mdlServiceResponse<mdlLoginResponse>> {
    return await GetResponse<mdlServiceResponse<mdlLoginResponse>>(
      "auth/login",
      pRequest
    );
  }

  export async function ForgotPassword(
    pRequest: mdlForgotPasswordRequest
  ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
    return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
      "auth/forgot-password",
      pRequest
    );
  }

  export async function ResetPassword(
    pRequest: mdlResetPasswordRequest
  ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
    return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
      "auth/reset-password",
      pRequest
    );
  }

  export async function GetUserAccount(pRequest: mdlUserAccountRequest): Promise<mdlServiceResponse<mdlUserAccountResponse>> {
    return await GetResponse<mdlServiceResponse<mdlUserAccountResponse>>(
      "auth/user-account",
      pRequest
    );
  }

  export async function UpdateUserAccount(pRequest: mdlUpdateUserAccountRequest): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
    return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
      "auth/update-user-account",
      pRequest
    );
  }
}
